module.exports = __webpack_public_path__ + "img/homecat-right.160b5d32.png";